// Helper estandar de shadcn: clsx para condicionales + tailwind-merge para
// que la ultima clase en conflicto gane (un `p-6` por props pisa el `p-4`
// default del componente). Mismo helper que ya usa apps/admin.
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...entradas: ClassValue[]): string {
  return twMerge(clsx(entradas));
}
